var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partial partial--login"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/qp_logo.svg"),"alt":"Quick Patient"}}),_c('form-login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }